export default {
  setAuditLogs(state: any, payload: Array<any>) {
    state.auditLogsList = payload;
  },
  setAuditLogs_all(state: any, payload: Array<any>) {
    state.auditLogsList_all = payload;
  },
};
